import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { ImageScaleView, animate } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleViewWithText, {
  ButtonScaleViewWithTextOpts,
} from 'src/lib/ui/components/ButtonScaleViewWithText';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import buttons from 'src/lib/ui/config/buttons';
import { magicLampsAnim } from './MagicLampsAnim';
import { magicLampsPlaySfx } from './magiclamps.utils';

export class MagicLampsCostButton extends ButtonScaleViewWithText {
  private flexBox: FlexBoxView;
  private mainText: LangBitmapFontTextView;
  private gemsIcon: ImageScaleView;
  private gemsText: LangBitmapFontTextView;

  constructor(opts: ButtonScaleViewWithTextOpts) {
    super({
      ...buttons.secondary,
      fontSize: 36,
      labelOffsetY: -2,
      font: 'Body',
      labelHorizontalAlign: 'left',
      labelWidth: 220,
      width: 390,
      height: 90,
      visible: false,
      centerOnOrigin: true,
      ...opts,
    });

    this.label.updateOpts({ visible: false });

    this.flexBox = new FlexBoxView({
      superview: this,
      x: 10,
      width: this.style.width - 20,
      height: this.style.height,
      flex: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      },
    });

    const gemsIconSize = 50;
    const mainTextWidth = (this.flexBox.style.width - gemsIconSize) * 0.6;
    const gemsTextWidth = (this.flexBox.style.width - gemsIconSize) * 0.4;

    this.mainText = new LangBitmapFontTextView({
      superview: this.flexBox,
      width: mainTextWidth,
      height: gemsIconSize,
      align: 'center',
      size: 36,
      font: 'Body',
    });

    this.gemsIcon = new ImageScaleView({
      superview: this.flexBox,
      width: gemsIconSize,
      height: gemsIconSize,
      offsetY: -2,
      image: 'assets/ui/shared/icons/gem.png',
      scaleMethod: 'contain',
    });

    this.gemsText = new LangBitmapFontTextView({
      superview: this.flexBox,
      width: gemsTextWidth,
      height: gemsIconSize,
      align: 'left',
      size: 36,
      font: 'Body',
      offsetY: 1,
      localeText: () => '0',
    });
  }

  public setup(args: { i18n: string; gems?: number }) {
    this.mainText.localeText = () => i18n(args.i18n);
    this.gemsText.localeText = () => args.gems?.toString() ?? '';
    this.gemsIcon.updateOpts({ visible: !!args.gems });
    this.gemsText.updateOpts({ visible: !!args.gems });
  }

  public async showAnimated() {
    if (!this.style.visible) magicLampsPlaySfx('move', { volume: 0.4 });
    this.show();
    await magicLampsAnim(this, { scale: 1 }, 250, animate.easeOutBack);
    this.updateOpts({ canHandleEvents: true });
  }

  public async hideAnimated() {
    this.updateOpts({ canHandleEvents: false });
    await magicLampsAnim(this, { scale: 0 }, 250, animate.easeInBack);
    this.hide();
  }
}
